/**
 * CMS Pages Global Scripts
 * These scripts run only on Shopify CMS pages created with PageFly app
 */

(function () {
  'use strict';

  const triggers = document.querySelectorAll('.open-modal-pop-up-form');
  const modals = document.querySelectorAll('.modal-pop-up-form-section-cms-pages');

  if (!triggers.length || !modals.length) return;

  function openModal(modal) {
    if (!modal) return;

    if (!modal.dataset.modalReady) {
      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop';

      const closeBtn = document.createElement('button');
      closeBtn.className = 'modal-close-x button-primary-solid';
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Close modal');
      closeBtn.innerHTML = '&times;';

      modal.insertBefore(backdrop, modal.firstChild);
      const content = modal.querySelector(':scope > *:not(.modal-backdrop)');
      (content || modal).appendChild(closeBtn);

      backdrop.addEventListener('click', () => closeModal(modal));
      closeBtn.addEventListener('click', () => closeModal(modal));

      modal.dataset.modalReady = 'true';
    }

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    if (!modal) return;
    if (modal.classList.contains('is-closing')) return;
    modal.classList.add('is-closing');
    modal.classList.remove('is-open');
    modal.addEventListener('animationend', function onClose(e) {
      if (e.target !== modal) return;
      modal.removeEventListener('animationend', onClose);
      modal.classList.remove('is-closing');
      document.body.style.overflow = '';
    }, { once: true });
  }

  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const modalIndex = trigger.dataset.modalIndex != null
        ? parseInt(trigger.dataset.modalIndex, 10)
        : index % modals.length;
      const modal = modals[modalIndex];
      openModal(modal);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      modals.forEach(modal => {
        if (modal.classList.contains('is-open')) closeModal(modal);
      });
    }
  });
})();
